export default __webpack_public_path__ + "static/media/2440.80d41d12.jpg";